// // ============================================================
// // src/components/admin/DoctorManageTab.js
// // Complete Add Doctor tab — full CRUD, image upload, live preview
// // Doctors added here appear live on the public Doctors section
// // ============================================================
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import api from "../../utils/api";

// // ── Card colour gradients (match public Doctors.js exactly) ──────────
// const CARD_COLORS = [
//   {
//     id: "teal",
//     label: "Teal",
//     bg: "linear-gradient(160deg,#0d7377 0%,#14a0a5 60%,#0a8f94 100%)",
//   },
//   {
//     id: "navy",
//     label: "Navy",
//     bg: "linear-gradient(160deg,#0a1628 0%,#1a3a6b 100%)",
//   },
//   {
//     id: "gold",
//     label: "Gold",
//     bg: "linear-gradient(160deg,#7c5a0a 0%,#b8860b 60%,#c9a845 100%)",
//   },
//   {
//     id: "plum",
//     label: "Plum",
//     bg: "linear-gradient(160deg,#3b0764 0%,#6b21a8 100%)",
//   },
//   {
//     id: "rose",
//     label: "Rose",
//     bg: "linear-gradient(160deg,#881337 0%,#be123c 100%)",
//   },
//   {
//     id: "slate",
//     label: "Slate",
//     bg: "linear-gradient(160deg,#1e293b 0%,#475569 100%)",
//   },
// ];

// const getBg = (id) =>
//   (CARD_COLORS.find((c) => c.id === id) || CARD_COLORS[0]).bg;

// const BLANK = {
//   name: "",
//   specialty: "",
//   role: "",
//   qualification: "",
//   experience: "",
//   rating: "4.9",
//   bio: "",
//   badgeLabel: "",
//   cardColor: "teal",
//   image: "",
//   isAvailable: true,
// };

// const INP = {
//   width: "100%",
//   padding: "9px 11px",
//   borderRadius: 8,
//   border: "1px solid #d1d5db",
//   fontSize: 13,
//   outline: "none",
//   boxSizing: "border-box",
//   fontFamily: "'DM Sans',sans-serif",
// };
// const LBL = {
//   display: "block",
//   fontSize: 11,
//   fontWeight: 700,
//   color: "#64748b",
//   textTransform: "uppercase",
//   letterSpacing: "0.5px",
//   marginBottom: 5,
// };

// // ── Live preview matching public Doctor card exactly ──────────────────
// function PreviewCard({ f }) {
//   const bg = getBg(f.cardColor);
//   return (
//     <div
//       style={{
//         borderRadius: 20,
//         overflow: "hidden",
//         width: "100%",
//         maxWidth: 280,
//         boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
//         background: "#fff",
//         fontFamily: "'DM Sans',sans-serif",
//         margin: "0 auto",
//       }}
//     >
//       {/* Coloured image band */}
//       <div
//         style={{
//           background: bg,
//           height: 200,
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         {f.badgeLabel && (
//           <div
//             style={{
//               position: "absolute",
//               top: 14,
//               right: 14,
//               background: "rgba(255,255,255,0.15)",
//               backdropFilter: "blur(6px)",
//               border: "1px solid rgba(255,255,255,0.3)",
//               borderRadius: 20,
//               fontSize: 11,
//               fontWeight: 700,
//               color: "#fff",
//               padding: "4px 14px",
//             }}
//           >
//             {f.badgeLabel}
//           </div>
//         )}
//         {f.image ? (
//           <img
//             src={f.image}
//             alt={f.name}
//             style={{
//               width: 130,
//               height: 130,
//               borderRadius: "50%",
//               objectFit: "cover",
//               objectPosition: "center top",
//               border: "3px solid rgba(255,255,255,0.3)",
//             }}
//           />
//         ) : (
//           <div style={{ fontSize: 72, opacity: 0.7 }}>🧑‍⚕️</div>
//         )}
//       </div>
//       {/* Info */}
//       <div style={{ padding: "22px 22px 20px" }}>
//         <div
//           style={{
//             fontFamily: "Cormorant Garamond,serif",
//             fontSize: 22,
//             fontWeight: 700,
//             color: "#0a1628",
//             marginBottom: 3,
//           }}
//         >
//           {f.name || "Doctor Name"}
//         </div>
//         <div
//           style={{
//             fontSize: 13,
//             color: "#0d7377",
//             fontWeight: 700,
//             marginBottom: 10,
//           }}
//         >
//           {f.specialty || "Specialty"}
//         </div>
//         <div
//           style={{
//             fontSize: 13,
//             color: "#555",
//             lineHeight: 1.6,
//             marginBottom: 14,
//             minHeight: 40,
//           }}
//         >
//           {f.bio || "Doctor bio will appear here..."}
//         </div>
//         <div style={{ display: "flex", gap: 16, fontSize: 13, color: "#666" }}>
//           {f.experience && <span>🎓 {f.experience} yrs exp.</span>}
//           {f.rating && <span>⭐ {f.rating} ★</span>}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Small admin list card ─────────────────────────────────────────────
// function AdminCard({ doc, onEdit, onDelete, onToggle }) {
//   const bg = getBg(doc.cardColor);
//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 16,
//         overflow: "hidden",
//         boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
//       }}
//     >
//       {/* Mini colour bar */}
//       <div
//         style={{
//           background: bg,
//           height: 80,
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         {doc.image ? (
//           <img
//             src={doc.image}
//             alt={doc.name}
//             style={{
//               width: 56,
//               height: 56,
//               borderRadius: "50%",
//               objectFit: "cover",
//               objectPosition: "center top",
//               border: "2px solid rgba(255,255,255,0.45)",
//             }}
//           />
//         ) : (
//           <div style={{ fontSize: 38, opacity: 0.75 }}>🧑‍⚕️</div>
//         )}
//         {/* Availability dot */}
//         <div
//           style={{
//             position: "absolute",
//             bottom: 8,
//             left: 10,
//             width: 10,
//             height: 10,
//             borderRadius: "50%",
//             background: doc.isAvailable !== false ? "#22c55e" : "#ef4444",
//             border: "2px solid #fff",
//           }}
//         />
//       </div>
//       <div style={{ padding: "12px 14px" }}>
//         <div
//           style={{
//             fontWeight: 700,
//             fontSize: 14,
//             color: "#0a1628",
//             marginBottom: 2,
//           }}
//         >
//           {doc.name}
//         </div>
//         <div
//           style={{
//             fontSize: 11,
//             color: "#0d7377",
//             fontWeight: 600,
//             marginBottom: 8,
//           }}
//         >
//           {doc.specialty}
//         </div>
//         <div
//           style={{
//             display: "flex",
//             gap: 10,
//             fontSize: 11,
//             color: "#888",
//             marginBottom: 10,
//           }}
//         >
//           {doc.experience && <span>🎓 {doc.experience} yrs</span>}
//           {doc.rating && <span>⭐ {doc.rating}</span>}
//         </div>
//         {/* Actions */}
//         <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
//           <button
//             onClick={() => onToggle(doc)}
//             style={{
//               flex: 1,
//               padding: "5px 0",
//               borderRadius: 7,
//               border: "none",
//               cursor: "pointer",
//               fontSize: 10,
//               fontWeight: 700,
//               background:
//                 doc.isAvailable !== false
//                   ? "rgba(239,68,68,0.08)"
//                   : "rgba(34,197,94,0.10)",
//               color: doc.isAvailable !== false ? "#ef4444" : "#16a34a",
//             }}
//           >
//             {doc.isAvailable !== false ? "Mark Unavail." : "Mark Avail."}
//           </button>
//           <button
//             onClick={() => onEdit(doc)}
//             style={{
//               padding: "5px 12px",
//               borderRadius: 7,
//               border: "1px solid #d1d5db",
//               background: "#f8fafc",
//               cursor: "pointer",
//               fontSize: 11,
//               fontWeight: 600,
//               color: "#374151",
//             }}
//           >
//             Edit
//           </button>
//           <button
//             onClick={() => onDelete(doc)}
//             style={{
//               padding: "5px 10px",
//               borderRadius: 7,
//               border: "1px solid #fca5a5",
//               background: "#fef2f2",
//               cursor: "pointer",
//               fontSize: 11,
//               fontWeight: 600,
//               color: "#dc2626",
//             }}
//           >
//             Del
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Main component ────────────────────────────────────────────────────
// export default function DoctorManageTab({ showNotify }) {
//   const [doctors, setDoctors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [view, setView] = useState("list"); // "list" | "form"
//   const [editing, setEditing] = useState(null);
//   const [form, setForm] = useState({ ...BLANK });
//   const [saving, setSaving] = useState(false);
//   const [imgBusy, setImgBusy] = useState(false);
//   const fileRef = useRef(null);

//   // ── Load ──────────────────────────────────────────────────────────
//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/doctors/manage");
//       setDoctors(Array.isArray(data) ? data : []);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, [showNotify]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   // ── Helpers ───────────────────────────────────────────────────────
//   const sf = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const openAdd = () => {
//     setEditing(null);
//     setForm({ ...BLANK });
//     setView("form");
//   };

//   const openEdit = (doc) => {
//     setEditing(doc);
//     setForm({
//       name: doc.name || "",
//       specialty: doc.specialty || "",
//       role: doc.role || "",
//       qualification: doc.qualification || "",
//       experience: doc.experience || "",
//       rating: doc.rating || "4.9",
//       bio: doc.bio || "",
//       badgeLabel: doc.badgeLabel || "",
//       cardColor: doc.cardColor || "teal",
//       image: doc.image || "",
//       isAvailable: doc.isAvailable !== false,
//     });
//     setView("form");
//   };

//   const cancelForm = () => {
//     setView("list");
//     setEditing(null);
//     setForm({ ...BLANK });
//   };

//   // ── Image file → base64 ──────────────────────────────────────────
//   const handleImageFile = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (file.size > 2.5 * 1024 * 1024) {
//       showNotify("Image Too Large", "Please use an image under 2.5 MB.", true);
//       return;
//     }
//     setImgBusy(true);
//     const reader = new FileReader();
//     reader.onload = (ev) => {
//       sf("image", ev.target.result);
//       setImgBusy(false);
//     };
//     reader.onerror = () => {
//       showNotify("Error", "Could not read image.", true);
//       setImgBusy(false);
//     };
//     reader.readAsDataURL(file);
//   };

//   // ── Save ─────────────────────────────────────────────────────────
//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       showNotify("Error", "Doctor name is required.", true);
//       return;
//     }
//     if (!form.specialty.trim()) {
//       showNotify("Error", "Specialty is required.", true);
//       return;
//     }
//     setSaving(true);
//     try {
//       const payload = {
//         name: form.name.trim(),
//         specialty: form.specialty.trim(),
//         role: form.role.trim(),
//         qualification: form.qualification.trim(),
//         experience: form.experience,
//         rating: form.rating,
//         bio: form.bio.trim(),
//         badgeLabel: form.badgeLabel.trim(),
//         cardColor: form.cardColor,
//         image: form.image,
//         isAvailable: form.isAvailable,
//       };
//       if (editing) {
//         await api.put("/doctors/manage/" + editing._id, payload);
//         showNotify(
//           "Updated ✓",
//           form.name + " profile updated. Live on website now.",
//         );
//       } else {
//         await api.post("/doctors/manage", payload);
//         showNotify(
//           "Doctor Added ✓",
//           form.name + " is now live on the website's Doctors section.",
//         );
//       }
//       cancelForm();
//       load();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setSaving(false);
//   };

//   // ── Delete ───────────────────────────────────────────────────────
//   const handleDelete = async (doc) => {
//     if (
//       !window.confirm(
//         "Delete Dr. " +
//           doc.name +
//           " permanently? This will remove them from the website.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/doctors/manage/" + doc._id);
//       showNotify("Deleted", doc.name + " removed.");
//       load();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   // ── Toggle availability ──────────────────────────────────────────
//   const handleToggle = async (doc) => {
//     try {
//       const next = doc.isAvailable === false ? true : false;
//       await api.patch("/doctors/manage/" + doc._id + "/availability", {
//         isAvailable: next,
//       });
//       showNotify(
//         next ? "Now Available ✓" : "Marked Unavailable",
//         "Dr. " + doc.name + " availability updated on website.",
//       );
//       load();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   // ════════════════ FORM VIEW ══════════════════════════════════════
//   if (view === "form") {
//     return (
//       <div style={{ paddingBottom: 40 }}>
//         {/* Top bar */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: 22,
//             flexWrap: "wrap",
//             gap: 10,
//           }}
//         >
//           <div>
//             <div className="admin-section-title" style={{ marginBottom: 2 }}>
//               {editing ? "✏️ Edit Doctor" : "➕ Add New Doctor"}
//             </div>
//             <div style={{ fontSize: 12, color: "#94a3b8" }}>
//               {editing
//                 ? "Changes go live on the website instantly."
//                 : "Doctor will appear live on the website's Doctors section."}
//             </div>
//           </div>
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={cancelForm}
//               style={{
//                 padding: "9px 18px",
//                 borderRadius: 8,
//                 border: "1px solid #d1d5db",
//                 background: "#f8fafc",
//                 cursor: "pointer",
//                 fontSize: 13,
//                 fontWeight: 600,
//                 color: "#374151",
//                 fontFamily: "'DM Sans',sans-serif",
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleSave}
//               disabled={saving}
//               style={{
//                 padding: "9px 22px",
//                 borderRadius: 8,
//                 border: "none",
//                 background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                 cursor: saving ? "default" : "pointer",
//                 fontSize: 13,
//                 fontWeight: 700,
//                 color: "#fff",
//                 opacity: saving ? 0.7 : 1,
//                 fontFamily: "'DM Sans',sans-serif",
//               }}
//             >
//               {saving
//                 ? "Saving..."
//                 : editing
//                   ? "💾 Update Doctor"
//                   : "💾 Add Doctor"}
//             </button>
//           </div>
//         </div>

//         {/* Two-column layout: form left, preview right */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 300px",
//             gap: 20,
//             alignItems: "start",
//           }}
//         >
//           {/* ── LEFT: form ── */}
//           <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//             {/* Photo section */}
//             <div
//               style={{
//                 background: "#fff",
//                 border: "1px solid #e5e7eb",
//                 borderRadius: 14,
//                 padding: 18,
//               }}
//             >
//               <div
//                 style={{
//                   fontWeight: 700,
//                   fontSize: 12,
//                   color: "#1e40af",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.5px",
//                   marginBottom: 14,
//                 }}
//               >
//                 Doctor Photo
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   gap: 16,
//                   flexWrap: "wrap",
//                   alignItems: "center",
//                 }}
//               >
//                 {/* Current photo circle */}
//                 <div
//                   style={{
//                     width: 90,
//                     height: 90,
//                     borderRadius: "50%",
//                     overflow: "hidden",
//                     border: "2px solid #e5e7eb",
//                     background: "#f8fafc",
//                     flexShrink: 0,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   {form.image ? (
//                     <img
//                       src={form.image}
//                       alt="preview"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                         objectPosition: "center top",
//                       }}
//                     />
//                   ) : (
//                     <span style={{ fontSize: 42 }}>🧑‍⚕️</span>
//                   )}
//                 </div>
//                 <div style={{ flex: 1, minWidth: 200 }}>
//                   <input
//                     ref={fileRef}
//                     type="file"
//                     accept="image/jpeg,image/png,image/webp"
//                     onChange={handleImageFile}
//                     style={{ display: "none" }}
//                   />
//                   <button
//                     onClick={() => fileRef.current && fileRef.current.click()}
//                     disabled={imgBusy}
//                     style={{
//                       padding: "8px 18px",
//                       borderRadius: 8,
//                       border: "1px solid #0d7377",
//                       background: "rgba(13,115,119,0.06)",
//                       color: "#0d7377",
//                       fontWeight: 700,
//                       fontSize: 12,
//                       cursor: imgBusy ? "default" : "pointer",
//                       fontFamily: "'DM Sans',sans-serif",
//                       marginBottom: 8,
//                       display: "block",
//                     }}
//                   >
//                     {imgBusy ? "Loading..." : "📸 Upload Photo"}
//                   </button>
//                   <div
//                     style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}
//                   >
//                     JPEG / PNG / WebP · Max 2.5MB
//                   </div>
//                   {/* URL input */}
//                   <label style={LBL}>Or paste image URL</label>
//                   <input
//                     type="url"
//                     value={
//                       form.image && form.image.startsWith("data:")
//                         ? ""
//                         : form.image
//                     }
//                     onChange={(e) => sf("image", e.target.value)}
//                     placeholder="https://example.com/photo.jpg"
//                     style={INP}
//                   />
//                   {form.image && (
//                     <button
//                       onClick={() => sf("image", "")}
//                       style={{
//                         marginTop: 5,
//                         background: "none",
//                         border: "none",
//                         color: "#ef4444",
//                         fontSize: 11,
//                         cursor: "pointer",
//                         padding: 0,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       ✕ Remove photo
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Basic info */}
//             <div
//               style={{
//                 background: "#fff",
//                 border: "1px solid #e5e7eb",
//                 borderRadius: 14,
//                 padding: 18,
//               }}
//             >
//               <div
//                 style={{
//                   fontWeight: 700,
//                   fontSize: 12,
//                   color: "#1e40af",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.5px",
//                   marginBottom: 14,
//                 }}
//               >
//                 Basic Information
//               </div>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: 12,
//                 }}
//               >
//                 <div>
//                   <label style={LBL}>Full Name *</label>
//                   <input
//                     value={form.name}
//                     onChange={(e) => sf("name", e.target.value)}
//                     placeholder="Dr. Arjun Sharma"
//                     style={INP}
//                   />
//                 </div>
//                 <div>
//                   <label style={LBL}>Specialty *</label>
//                   <input
//                     value={form.specialty}
//                     onChange={(e) => sf("specialty", e.target.value)}
//                     placeholder="Cosmetic & Aesthetic Dentist"
//                     style={INP}
//                   />
//                 </div>
//                 <div>
//                   <label style={LBL}>Role / Title</label>
//                   <input
//                     value={form.role}
//                     onChange={(e) => sf("role", e.target.value)}
//                     placeholder="Chief Dental Surgeon"
//                     style={INP}
//                   />
//                 </div>
//                 <div>
//                   <label style={LBL}>Qualification</label>
//                   <input
//                     value={form.qualification}
//                     onChange={(e) => sf("qualification", e.target.value)}
//                     placeholder="BDS, MDS (Oral Surgery)"
//                     style={INP}
//                   />
//                 </div>
//                 <div>
//                   <label style={LBL}>Years Experience</label>
//                   <input
//                     type="number"
//                     min="0"
//                     max="60"
//                     value={form.experience}
//                     onChange={(e) => sf("experience", e.target.value)}
//                     placeholder="18"
//                     style={INP}
//                   />
//                 </div>
//                 <div>
//                   <label style={LBL}>Rating (1–5)</label>
//                   <input
//                     type="number"
//                     min="1"
//                     max="5"
//                     step="0.1"
//                     value={form.rating}
//                     onChange={(e) => sf("rating", e.target.value)}
//                     placeholder="4.9"
//                     style={INP}
//                   />
//                 </div>
//               </div>
//               <div style={{ marginTop: 12 }}>
//                 <label style={LBL}>Bio / Description</label>
//                 <textarea
//                   rows={3}
//                   value={form.bio}
//                   onChange={(e) => sf("bio", e.target.value)}
//                   placeholder="BDS, MDS (Orthodontics). Certified Invisalign provider. Specialises in complex bite corrections..."
//                   style={{ ...INP, resize: "vertical", lineHeight: 1.55 }}
//                 />
//               </div>
//             </div>

//             {/* Card appearance */}
//             <div
//               style={{
//                 background: "#fff",
//                 border: "1px solid #e5e7eb",
//                 borderRadius: 14,
//                 padding: 18,
//               }}
//             >
//               <div
//                 style={{
//                   fontWeight: 700,
//                   fontSize: 12,
//                   color: "#1e40af",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.5px",
//                   marginBottom: 14,
//                 }}
//               >
//                 Card Appearance
//               </div>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: 12,
//                   alignItems: "start",
//                 }}
//               >
//                 <div>
//                   <label style={LBL}>Card Colour</label>
//                   <div
//                     style={{
//                       display: "flex",
//                       gap: 8,
//                       flexWrap: "wrap",
//                       marginTop: 4,
//                     }}
//                   >
//                     {CARD_COLORS.map((c) => (
//                       <button
//                         key={c.id}
//                         title={c.label}
//                         onClick={() => sf("cardColor", c.id)}
//                         style={{
//                           width: 32,
//                           height: 32,
//                           borderRadius: "50%",
//                           background: c.bg,
//                           border:
//                             form.cardColor === c.id
//                               ? "3px solid #0a1628"
//                               : "2px solid rgba(0,0,0,0.12)",
//                           cursor: "pointer",
//                           outline: "none",
//                           boxShadow:
//                             form.cardColor === c.id
//                               ? "0 0 0 2px #fff inset"
//                               : "none",
//                           transition: "transform 0.15s",
//                         }}
//                       />
//                     ))}
//                   </div>
//                 </div>
//                 <div>
//                   <label style={LBL}>Badge Label (top-right)</label>
//                   <input
//                     value={form.badgeLabel}
//                     onChange={(e) => sf("badgeLabel", e.target.value)}
//                     placeholder="e.g. Chief Surgeon"
//                     style={INP}
//                   />
//                 </div>
//               </div>
//               {/* Availability toggle */}
//               <div
//                 style={{
//                   marginTop: 14,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 12,
//                 }}
//               >
//                 <label style={{ ...LBL, marginBottom: 0 }}>
//                   Available Today
//                 </label>
//                 <div
//                   onClick={() => sf("isAvailable", !form.isAvailable)}
//                   style={{
//                     width: 48,
//                     height: 26,
//                     borderRadius: 13,
//                     cursor: "pointer",
//                     background: form.isAvailable ? "#22c55e" : "#d1d5db",
//                     position: "relative",
//                     transition: "background 0.2s",
//                   }}
//                 >
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: 3,
//                       left: form.isAvailable ? 25 : 3,
//                       width: 20,
//                       height: 20,
//                       borderRadius: "50%",
//                       background: "#fff",
//                       boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
//                       transition: "left 0.2s",
//                     }}
//                   />
//                 </div>
//                 <span
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 600,
//                     color: form.isAvailable ? "#16a34a" : "#9ca3af",
//                   }}
//                 >
//                   {form.isAvailable ? "Available" : "Unavailable"}
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* ── RIGHT: live preview ── */}
//           <div>
//             <div
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#94a3b8",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 marginBottom: 12,
//                 textAlign: "center",
//               }}
//             >
//               Live Preview
//             </div>
//             <PreviewCard f={form} />
//             <div
//               style={{
//                 marginTop: 10,
//                 fontSize: 11,
//                 color: "#94a3b8",
//                 textAlign: "center",
//                 lineHeight: 1.5,
//               }}
//             >
//               This is exactly how the card
//               <br />
//               will appear on the website.
//             </div>
//           </div>
//         </div>

//         {/* Bottom save bar */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: 10,
//             marginTop: 24,
//           }}
//         >
//           <button
//             onClick={cancelForm}
//             style={{
//               padding: "10px 22px",
//               borderRadius: 8,
//               border: "1px solid #d1d5db",
//               background: "#f8fafc",
//               cursor: "pointer",
//               fontSize: 13,
//               fontWeight: 600,
//               color: "#374151",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSave}
//             disabled={saving}
//             style={{
//               padding: "10px 28px",
//               borderRadius: 8,
//               border: "none",
//               background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//               cursor: saving ? "default" : "pointer",
//               fontSize: 13,
//               fontWeight: 700,
//               color: "#fff",
//               opacity: saving ? 0.7 : 1,
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {saving
//               ? "Saving..."
//               : editing
//                 ? "💾 Update Doctor"
//                 : "💾 Add Doctor"}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   // ════════════════ LIST VIEW ══════════════════════════════════════
//   return (
//     <div style={{ paddingBottom: 40 }}>
//       <div className="admin-section-title">Manage Doctors</div>
//       <div className="admin-section-desc" style={{ marginBottom: 18 }}>
//         Add, edit or remove doctors. Changes appear{" "}
//         <strong>live on the website instantly</strong> in the Doctors section.
//         Upload real photos for best results.
//       </div>

//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: 20,
//           flexWrap: "wrap",
//           gap: 10,
//         }}
//       >
//         <div style={{ fontSize: 13, color: "#94a3b8" }}>
//           {loading
//             ? "Loading..."
//             : `${doctors.length} doctor${doctors.length !== 1 ? "s" : ""} on team`}
//         </div>
//         <button
//           onClick={openAdd}
//           style={{
//             padding: "9px 22px",
//             borderRadius: 8,
//             border: "none",
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             cursor: "pointer",
//             fontSize: 13,
//             fontWeight: 700,
//             color: "#fff",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           + Add New Doctor
//         </button>
//       </div>

//       {loading ? (
//         <div
//           style={{
//             textAlign: "center",
//             padding: 40,
//             color: "#94a3b8",
//             fontSize: 14,
//           }}
//         >
//           Loading doctors...
//         </div>
//       ) : doctors.length === 0 ? (
//         <div
//           style={{
//             textAlign: "center",
//             padding: 48,
//             background: "#f8fafc",
//             borderRadius: 14,
//             color: "#94a3b8",
//             fontSize: 14,
//             border: "1px dashed #e2e8f0",
//           }}
//         >
//           No doctors added yet.
//           <br />
//           <button
//             onClick={openAdd}
//             style={{
//               marginTop: 12,
//               padding: "8px 20px",
//               borderRadius: 8,
//               border: "1px solid #0d7377",
//               background: "rgba(13,115,119,0.07)",
//               color: "#0d7377",
//               fontWeight: 700,
//               fontSize: 13,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Your First Doctor
//           </button>
//         </div>
//       ) : (
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
//             gap: 16,
//           }}
//         >
//           {doctors.map((doc) => (
//             <AdminCard
//               key={doc._id}
//               doc={doc}
//               onEdit={openEdit}
//               onDelete={handleDelete}
//               onToggle={handleToggle}
//             />
//           ))}
//         </div>
//       )}

//       {/* Info tip */}
//       <div
//         style={{
//           marginTop: 28,
//           background: "rgba(13,115,119,0.06)",
//           border: "1px solid rgba(13,115,119,0.2)",
//           borderRadius: 12,
//           padding: "14px 18px",
//         }}
//       >
//         <div
//           style={{
//             fontSize: 12,
//             fontWeight: 700,
//             color: "#0d7377",
//             marginBottom: 6,
//           }}
//         >
//           ℹ️ How this works
//         </div>
//         <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.75 }}>
//           • Doctors added here appear automatically on the public website's{" "}
//           <strong>Our Doctors</strong> section.
//           <br />
//           • Upload a real photo — it fits perfectly in the circular frame on the
//           card.
//           <br />
//           • Toggle availability to show a green/red dot on the website next to
//           the doctor's name.
//           <br />• Card colour, badge label, and all details update live the
//           moment you save.
//         </div>
//       </div>
//     </div>
//   );
// }

///////////////////////final test//////////////

// // ============================================================
// // src/components/admin/DoctorManageTab.js
// // Complete Add Doctor tab — full CRUD, image upload, live preview
// // Doctors added here appear live on the public Doctors section
// // ============================================================
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import api from "../../utils/api";

// // ── Card colour gradients (match public Doctors.js exactly) ──────────
// const CARD_COLORS = [
//   {
//     id: "teal",
//     label: "Teal",
//     bg: "linear-gradient(160deg,#0d7377 0%,#14a0a5 60%,#0a8f94 100%)",
//   },
//   {
//     id: "navy",
//     label: "Navy",
//     bg: "linear-gradient(160deg,#0a1628 0%,#1a3a6b 100%)",
//   },
//   {
//     id: "gold",
//     label: "Gold",
//     bg: "linear-gradient(160deg,#7c5a0a 0%,#b8860b 60%,#c9a845 100%)",
//   },
//   {
//     id: "plum",
//     label: "Plum",
//     bg: "linear-gradient(160deg,#3b0764 0%,#6b21a8 100%)",
//   },
//   {
//     id: "rose",
//     label: "Rose",
//     bg: "linear-gradient(160deg,#881337 0%,#be123c 100%)",
//   },
//   {
//     id: "slate",
//     label: "Slate",
//     bg: "linear-gradient(160deg,#1e293b 0%,#475569 100%)",
//   },
// ];

// const getBg = (id) =>
//   (CARD_COLORS.find((c) => c.id === id) || CARD_COLORS[0]).bg;

// const BLANK = {
//   name: "",
//   specialty: "",
//   role: "",
//   qualification: "",
//   experience: "",
//   rating: "4.9",
//   bio: "",
//   badgeLabel: "",
//   cardColor: "teal",
//   image: "",
//   isAvailable: true,
// };

// const INP = {
//   width: "100%",
//   padding: "9px 11px",
//   borderRadius: 8,
//   border: "1px solid #d1d5db",
//   fontSize: 13,
//   outline: "none",
//   boxSizing: "border-box",
//   fontFamily: "'DM Sans',sans-serif",
// };
// const LBL = {
//   display: "block",
//   fontSize: 11,
//   fontWeight: 700,
//   color: "#64748b",
//   textTransform: "uppercase",
//   letterSpacing: "0.5px",
//   marginBottom: 5,
// };

// // ── Live preview matching public Doctor card exactly ──────────────────
// function PreviewCard({ f }) {
//   const bg = getBg(f.cardColor);
//   return (
//     <div
//       style={{
//         borderRadius: 20,
//         overflow: "hidden",
//         width: "100%",
//         maxWidth: 280,
//         boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
//         background: "#fff",
//         fontFamily: "'DM Sans',sans-serif",
//         margin: "0 auto",
//       }}
//     >
//       {/* Coloured image band */}
//       <div
//         style={{
//           background: bg,
//           height: 200,
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         {f.badgeLabel && (
//           <div
//             style={{
//               position: "absolute",
//               top: 14,
//               right: 14,
//               background: "rgba(255,255,255,0.15)",
//               backdropFilter: "blur(6px)",
//               border: "1px solid rgba(255,255,255,0.3)",
//               borderRadius: 20,
//               fontSize: 11,
//               fontWeight: 700,
//               color: "#fff",
//               padding: "4px 14px",
//             }}
//           >
//             {f.badgeLabel}
//           </div>
//         )}
//         {f.image ? (
//           <img
//             src={f.image}
//             alt={f.name}
//             style={{
//               width: 130,
//               height: 130,
//               borderRadius: "50%",
//               objectFit: "cover",
//               objectPosition: "center top",
//               border: "3px solid rgba(255,255,255,0.3)",
//             }}
//           />
//         ) : (
//           <div style={{ fontSize: 72, opacity: 0.7 }}>🧑‍⚕️</div>
//         )}
//       </div>
//       {/* Info */}
//       <div style={{ padding: "22px 22px 20px" }}>
//         <div
//           style={{
//             fontFamily: "Cormorant Garamond,serif",
//             fontSize: 22,
//             fontWeight: 700,
//             color: "#0a1628",
//             marginBottom: 3,
//           }}
//         >
//           {f.name || "Doctor Name"}
//         </div>
//         <div
//           style={{
//             fontSize: 13,
//             color: "#0d7377",
//             fontWeight: 700,
//             marginBottom: 10,
//           }}
//         >
//           {f.specialty || "Specialty"}
//         </div>
//         <div
//           style={{
//             fontSize: 13,
//             color: "#555",
//             lineHeight: 1.6,
//             marginBottom: 14,
//             minHeight: 40,
//           }}
//         >
//           {f.bio || "Doctor bio will appear here..."}
//         </div>
//         <div style={{ display: "flex", gap: 16, fontSize: 13, color: "#666" }}>
//           {f.experience && <span>🎓 {f.experience} yrs exp.</span>}
//           {f.rating && <span>⭐ {f.rating} ★</span>}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Small admin list card ─────────────────────────────────────────────
// function AdminCard({ doc, onEdit, onDelete, onToggle }) {
//   const bg = getBg(doc.cardColor);
//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         borderRadius: 16,
//         overflow: "hidden",
//         boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
//       }}
//     >
//       {/* Mini colour bar */}
//       <div
//         style={{
//           background: bg,
//           height: 80,
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         {doc.image ? (
//           <img
//             src={doc.image}
//             alt={doc.name}
//             style={{
//               width: 56,
//               height: 56,
//               borderRadius: "50%",
//               objectFit: "cover",
//               objectPosition: "center top",
//               border: "2px solid rgba(255,255,255,0.45)",
//             }}
//           />
//         ) : (
//           <div style={{ fontSize: 38, opacity: 0.75 }}>🧑‍⚕️</div>
//         )}
//         {/* Availability dot */}
//         <div
//           style={{
//             position: "absolute",
//             bottom: 8,
//             left: 10,
//             width: 10,
//             height: 10,
//             borderRadius: "50%",
//             background: doc.isAvailable !== false ? "#22c55e" : "#ef4444",
//             border: "2px solid #fff",
//           }}
//         />
//       </div>
//       <div style={{ padding: "12px 14px" }}>
//         <div
//           style={{
//             fontWeight: 700,
//             fontSize: 14,
//             color: "#0a1628",
//             marginBottom: 2,
//           }}
//         >
//           {doc.name}
//         </div>
//         <div
//           style={{
//             fontSize: 11,
//             color: "#0d7377",
//             fontWeight: 600,
//             marginBottom: 8,
//           }}
//         >
//           {doc.specialty}
//         </div>
//         <div
//           style={{
//             display: "flex",
//             gap: 10,
//             fontSize: 11,
//             color: "#888",
//             marginBottom: 10,
//           }}
//         >
//           {doc.experience && <span>🎓 {doc.experience} yrs</span>}
//           {doc.rating && <span>⭐ {doc.rating}</span>}
//         </div>
//         {/* Actions */}
//         <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
//           <button
//             onClick={() => onToggle(doc)}
//             style={{
//               flex: 1,
//               padding: "5px 0",
//               borderRadius: 7,
//               border: "none",
//               cursor: "pointer",
//               fontSize: 10,
//               fontWeight: 700,
//               background:
//                 doc.isAvailable !== false
//                   ? "rgba(239,68,68,0.08)"
//                   : "rgba(34,197,94,0.10)",
//               color: doc.isAvailable !== false ? "#ef4444" : "#16a34a",
//             }}
//           >
//             {doc.isAvailable !== false ? "Mark Unavail." : "Mark Avail."}
//           </button>
//           <button
//             onClick={() => onEdit(doc)}
//             style={{
//               padding: "5px 12px",
//               borderRadius: 7,
//               border: "1px solid #d1d5db",
//               background: "#f8fafc",
//               cursor: "pointer",
//               fontSize: 11,
//               fontWeight: 600,
//               color: "#374151",
//             }}
//           >
//             Edit
//           </button>
//           <button
//             onClick={() => onDelete(doc)}
//             style={{
//               padding: "5px 10px",
//               borderRadius: 7,
//               border: "1px solid #fca5a5",
//               background: "#fef2f2",
//               cursor: "pointer",
//               fontSize: 11,
//               fontWeight: 600,
//               color: "#dc2626",
//             }}
//           >
//             Del
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Main component ────────────────────────────────────────────────────
// export default function DoctorManageTab({ showNotify }) {
//   const [doctors, setDoctors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [view, setView] = useState("list"); // "list" | "form"
//   const [editing, setEditing] = useState(null);
//   const [form, setForm] = useState({ ...BLANK });
//   const [saving, setSaving] = useState(false);
//   const [imgBusy, setImgBusy] = useState(false);
//   const fileRef = useRef(null);

//   // ── Load ──────────────────────────────────────────────────────────
//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/doctors/manage");
//       setDoctors(Array.isArray(data) ? data : []);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, [showNotify]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   // ── Helpers ───────────────────────────────────────────────────────
//   const sf = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const openAdd = () => {
//     setEditing(null);
//     setForm({ ...BLANK });
//     setView("form");
//   };

//   const openEdit = (doc) => {
//     setEditing(doc);
//     setForm({
//       name: doc.name || "",
//       specialty: doc.specialty || "",
//       role: doc.role || "",
//       qualification: doc.qualification || "",
//       experience: doc.experience || "",
//       rating: doc.rating || "4.9",
//       bio: doc.bio || "",
//       badgeLabel: doc.badgeLabel || "",
//       cardColor: doc.cardColor || "teal",
//       image: doc.image || "",
//       isAvailable: doc.isAvailable !== false,
//     });
//     setView("form");
//   };

//   const cancelForm = () => {
//     setView("list");
//     setEditing(null);
//     setForm({ ...BLANK });
//   };

//   // ── Image file → base64 ──────────────────────────────────────────
//   const handleImageFile = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (file.size > 2.5 * 1024 * 1024) {
//       showNotify("Image Too Large", "Please use an image under 2.5 MB.", true);
//       return;
//     }
//     setImgBusy(true);
//     const reader = new FileReader();
//     reader.onload = (ev) => {
//       sf("image", ev.target.result);
//       setImgBusy(false);
//     };
//     reader.onerror = () => {
//       showNotify("Error", "Could not read image.", true);
//       setImgBusy(false);
//     };
//     reader.readAsDataURL(file);
//   };

//   // ── Save ─────────────────────────────────────────────────────────
//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       showNotify("Error", "Doctor name is required.", true);
//       return;
//     }
//     if (!form.specialty.trim()) {
//       showNotify("Error", "Specialty is required.", true);
//       return;
//     }
//     setSaving(true);
//     try {
//       const payload = {
//         name: form.name.trim(),
//         specialty: form.specialty.trim(),
//         role: form.role.trim(),
//         qualification: form.qualification.trim(),
//         experience: form.experience,
//         rating: form.rating,
//         bio: form.bio.trim(),
//         badgeLabel: form.badgeLabel.trim(),
//         cardColor: form.cardColor,
//         image: form.image,
//         isAvailable: form.isAvailable,
//       };
//       if (editing) {
//         await api.put("/doctors/manage/" + editing._id, payload);
//         showNotify(
//           "Updated ✓",
//           form.name + " profile updated. Live on website now.",
//         );
//       } else {
//         await api.post("/doctors/manage", payload);
//         showNotify(
//           "Doctor Added ✓",
//           form.name + " is now live on the website's Doctors section.",
//         );
//       }
//       cancelForm();
//       load();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setSaving(false);
//   };

//   // ── Delete ───────────────────────────────────────────────────────
//   const handleDelete = async (doc) => {
//     if (
//       !window.confirm(
//         "Delete Dr. " +
//           doc.name +
//           " permanently? This will remove them from the website.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/doctors/manage/" + doc._id);
//       showNotify("Deleted", doc.name + " removed.");
//       load();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   // ── Toggle availability ──────────────────────────────────────────
//   const handleToggle = async (doc) => {
//     try {
//       const next = doc.isAvailable === false ? true : false;
//       await api.patch("/doctors/manage/" + doc._id + "/availability", {
//         isAvailable: next,
//       });
//       showNotify(
//         next ? "Now Available ✓" : "Marked Unavailable",
//         "Dr. " + doc.name + " availability updated on website.",
//       );
//       load();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   // ════════════════ FORM VIEW ══════════════════════════════════════
//   if (view === "form") {
//     return (
//       <div style={{ paddingBottom: 40 }}>
//         {/* Top bar */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: 22,
//             flexWrap: "wrap",
//             gap: 10,
//           }}
//         >
//           <div>
//             <div className="admin-section-title" style={{ marginBottom: 2 }}>
//               {editing ? "✏️ Edit Doctor" : "➕ Add New Doctor"}
//             </div>
//             <div style={{ fontSize: 12, color: "#94a3b8" }}>
//               {editing
//                 ? "Changes go live on the website instantly."
//                 : "Doctor will appear live on the website's Doctors section."}
//             </div>
//           </div>
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={cancelForm}
//               style={{
//                 padding: "9px 18px",
//                 borderRadius: 8,
//                 border: "1px solid #d1d5db",
//                 background: "#f8fafc",
//                 cursor: "pointer",
//                 fontSize: 13,
//                 fontWeight: 600,
//                 color: "#374151",
//                 fontFamily: "'DM Sans',sans-serif",
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleSave}
//               disabled={saving}
//               style={{
//                 padding: "9px 22px",
//                 borderRadius: 8,
//                 border: "none",
//                 background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                 cursor: saving ? "default" : "pointer",
//                 fontSize: 13,
//                 fontWeight: 700,
//                 color: "#fff",
//                 opacity: saving ? 0.7 : 1,
//                 fontFamily: "'DM Sans',sans-serif",
//               }}
//             >
//               {saving
//                 ? "Saving..."
//                 : editing
//                   ? "💾 Update Doctor"
//                   : "💾 Add Doctor"}
//             </button>
//           </div>
//         </div>

//         {/* Two-column layout: form left, preview right */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 300px",
//             gap: 20,
//             alignItems: "start",
//           }}
//         >
//           {/* ── LEFT: form ── */}
//           <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//             {/* Photo section */}
//             <div
//               style={{
//                 background: "#fff",
//                 border: "1px solid #e5e7eb",
//                 borderRadius: 14,
//                 padding: 18,
//               }}
//             >
//               <div
//                 style={{
//                   fontWeight: 700,
//                   fontSize: 12,
//                   color: "#1e40af",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.5px",
//                   marginBottom: 14,
//                 }}
//               >
//                 Doctor Photo
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   gap: 16,
//                   flexWrap: "wrap",
//                   alignItems: "center",
//                 }}
//               >
//                 {/* Current photo circle */}
//                 <div
//                   style={{
//                     width: 90,
//                     height: 90,
//                     borderRadius: "50%",
//                     overflow: "hidden",
//                     border: "2px solid #e5e7eb",
//                     background: "#f8fafc",
//                     flexShrink: 0,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   {form.image ? (
//                     <img
//                       src={form.image}
//                       alt="preview"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                         objectPosition: "center top",
//                       }}
//                     />
//                   ) : (
//                     <span style={{ fontSize: 42 }}>🧑‍⚕️</span>
//                   )}
//                 </div>
//                 <div style={{ flex: 1, minWidth: 200 }}>
//                   <input
//                     ref={fileRef}
//                     type="file"
//                     accept="image/jpeg,image/png,image/webp"
//                     onChange={handleImageFile}
//                     style={{ display: "none" }}
//                   />
//                   <button
//                     onClick={() => fileRef.current && fileRef.current.click()}
//                     disabled={imgBusy}
//                     style={{
//                       padding: "8px 18px",
//                       borderRadius: 8,
//                       border: "1px solid #0d7377",
//                       background: "rgba(13,115,119,0.06)",
//                       color: "#0d7377",
//                       fontWeight: 700,
//                       fontSize: 12,
//                       cursor: imgBusy ? "default" : "pointer",
//                       fontFamily: "'DM Sans',sans-serif",
//                       marginBottom: 8,
//                       display: "block",
//                     }}
//                   >
//                     {imgBusy ? "Loading..." : "📸 Upload Photo"}
//                   </button>
//                   <div
//                     style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}
//                   >
//                     JPEG / PNG / WebP · Max 2.5MB
//                   </div>
//                   {/* URL input */}
//                   <label style={LBL}>Or paste image URL</label>
//                   <input
//                     type="url"
//                     value={
//                       form.image && form.image.startsWith("data:")
//                         ? ""
//                         : form.image
//                     }
//                     onChange={(e) => sf("image", e.target.value)}
//                     placeholder="https://example.com/photo.jpg"
//                     style={INP}
//                   />
//                   {form.image && (
//                     <button
//                       onClick={() => sf("image", "")}
//                       style={{
//                         marginTop: 5,
//                         background: "none",
//                         border: "none",
//                         color: "#ef4444",
//                         fontSize: 11,
//                         cursor: "pointer",
//                         padding: 0,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       ✕ Remove photo
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Basic info */}
//             <div
//               style={{
//                 background: "#fff",
//                 border: "1px solid #e5e7eb",
//                 borderRadius: 14,
//                 padding: 18,
//               }}
//             >
//               <div
//                 style={{
//                   fontWeight: 700,
//                   fontSize: 12,
//                   color: "#1e40af",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.5px",
//                   marginBottom: 14,
//                 }}
//               >
//                 Basic Information
//               </div>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: 12,
//                 }}
//               >
//                 <div>
//                   <label style={LBL}>Full Name *</label>
//                   <input
//                     value={form.name}
//                     onChange={(e) => sf("name", e.target.value)}
//                     placeholder="Dr. Arjun Sharma"
//                     style={INP}
//                   />
//                 </div>
//                 <div>
//                   <label style={LBL}>Specialty *</label>
//                   <input
//                     value={form.specialty}
//                     onChange={(e) => sf("specialty", e.target.value)}
//                     placeholder="Cosmetic & Aesthetic Dentist"
//                     style={INP}
//                   />
//                 </div>
//                 <div>
//                   <label style={LBL}>Role / Title</label>
//                   <input
//                     value={form.role}
//                     onChange={(e) => sf("role", e.target.value)}
//                     placeholder="Chief Dental Surgeon"
//                     style={INP}
//                   />
//                 </div>
//                 <div>
//                   <label style={LBL}>Qualification</label>
//                   <input
//                     value={form.qualification}
//                     onChange={(e) => sf("qualification", e.target.value)}
//                     placeholder="BDS, MDS (Oral Surgery)"
//                     style={INP}
//                   />
//                 </div>
//                 <div>
//                   <label style={LBL}>Years Experience</label>
//                   <input
//                     type="number"
//                     min="0"
//                     max="60"
//                     value={form.experience}
//                     onChange={(e) => sf("experience", e.target.value)}
//                     placeholder="18"
//                     style={INP}
//                   />
//                 </div>
//                 <div>
//                   <label style={LBL}>Rating (1–5)</label>
//                   <input
//                     type="number"
//                     min="1"
//                     max="5"
//                     step="0.1"
//                     value={form.rating}
//                     onChange={(e) => sf("rating", e.target.value)}
//                     placeholder="4.9"
//                     style={INP}
//                   />
//                 </div>
//               </div>
//               <div style={{ marginTop: 12 }}>
//                 <label style={LBL}>Bio / Description</label>
//                 <textarea
//                   rows={3}
//                   value={form.bio}
//                   onChange={(e) => sf("bio", e.target.value)}
//                   placeholder="BDS, MDS (Orthodontics). Certified Invisalign provider. Specialises in complex bite corrections..."
//                   style={{ ...INP, resize: "vertical", lineHeight: 1.55 }}
//                 />
//               </div>
//             </div>

//             {/* Card appearance */}
//             <div
//               style={{
//                 background: "#fff",
//                 border: "1px solid #e5e7eb",
//                 borderRadius: 14,
//                 padding: 18,
//               }}
//             >
//               <div
//                 style={{
//                   fontWeight: 700,
//                   fontSize: 12,
//                   color: "#1e40af",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.5px",
//                   marginBottom: 14,
//                 }}
//               >
//                 Card Appearance
//               </div>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: 12,
//                   alignItems: "start",
//                 }}
//               >
//                 <div>
//                   <label style={LBL}>Card Colour</label>
//                   <div
//                     style={{
//                       display: "flex",
//                       gap: 8,
//                       flexWrap: "wrap",
//                       marginTop: 4,
//                     }}
//                   >
//                     {CARD_COLORS.map((c) => (
//                       <button
//                         key={c.id}
//                         title={c.label}
//                         onClick={() => sf("cardColor", c.id)}
//                         style={{
//                           width: 32,
//                           height: 32,
//                           borderRadius: "50%",
//                           background: c.bg,
//                           border:
//                             form.cardColor === c.id
//                               ? "3px solid #0a1628"
//                               : "2px solid rgba(0,0,0,0.12)",
//                           cursor: "pointer",
//                           outline: "none",
//                           boxShadow:
//                             form.cardColor === c.id
//                               ? "0 0 0 2px #fff inset"
//                               : "none",
//                           transition: "transform 0.15s",
//                         }}
//                       />
//                     ))}
//                   </div>
//                 </div>
//                 <div>
//                   <label style={LBL}>Badge Label (top-right)</label>
//                   <input
//                     value={form.badgeLabel}
//                     onChange={(e) => sf("badgeLabel", e.target.value)}
//                     placeholder="e.g. Chief Surgeon"
//                     style={INP}
//                   />
//                 </div>
//               </div>
//               {/* Availability toggle */}
//               <div
//                 style={{
//                   marginTop: 14,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 12,
//                 }}
//               >
//                 <label style={{ ...LBL, marginBottom: 0 }}>
//                   Available Today
//                 </label>
//                 <div
//                   onClick={() => sf("isAvailable", !form.isAvailable)}
//                   style={{
//                     width: 48,
//                     height: 26,
//                     borderRadius: 13,
//                     cursor: "pointer",
//                     background: form.isAvailable ? "#22c55e" : "#d1d5db",
//                     position: "relative",
//                     transition: "background 0.2s",
//                   }}
//                 >
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: 3,
//                       left: form.isAvailable ? 25 : 3,
//                       width: 20,
//                       height: 20,
//                       borderRadius: "50%",
//                       background: "#fff",
//                       boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
//                       transition: "left 0.2s",
//                     }}
//                   />
//                 </div>
//                 <span
//                   style={{
//                     fontSize: 12,
//                     fontWeight: 600,
//                     color: form.isAvailable ? "#16a34a" : "#9ca3af",
//                   }}
//                 >
//                   {form.isAvailable ? "Available" : "Unavailable"}
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* ── RIGHT: live preview ── */}
//           <div>
//             <div
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#94a3b8",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 marginBottom: 12,
//                 textAlign: "center",
//               }}
//             >
//               Live Preview
//             </div>
//             <PreviewCard f={form} />
//             <div
//               style={{
//                 marginTop: 10,
//                 fontSize: 11,
//                 color: "#94a3b8",
//                 textAlign: "center",
//                 lineHeight: 1.5,
//               }}
//             >
//               This is exactly how the card
//               <br />
//               will appear on the website.
//             </div>
//           </div>
//         </div>

//         {/* Bottom save bar */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: 10,
//             marginTop: 24,
//           }}
//         >
//           <button
//             onClick={cancelForm}
//             style={{
//               padding: "10px 22px",
//               borderRadius: 8,
//               border: "1px solid #d1d5db",
//               background: "#f8fafc",
//               cursor: "pointer",
//               fontSize: 13,
//               fontWeight: 600,
//               color: "#374151",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSave}
//             disabled={saving}
//             style={{
//               padding: "10px 28px",
//               borderRadius: 8,
//               border: "none",
//               background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//               cursor: saving ? "default" : "pointer",
//               fontSize: 13,
//               fontWeight: 700,
//               color: "#fff",
//               opacity: saving ? 0.7 : 1,
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {saving
//               ? "Saving..."
//               : editing
//                 ? "💾 Update Doctor"
//                 : "💾 Add Doctor"}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   // ════════════════ LIST VIEW ══════════════════════════════════════
//   return (
//     <div style={{ paddingBottom: 40 }}>
//       <div className="admin-section-title">Manage Doctors</div>
//       <div className="admin-section-desc" style={{ marginBottom: 18 }}>
//         Add, edit or remove doctors. Changes appear{" "}
//         <strong>live on the website instantly</strong> in the Doctors section.
//         Upload real photos for best results.
//       </div>

//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: 20,
//           flexWrap: "wrap",
//           gap: 10,
//         }}
//       >
//         <div style={{ fontSize: 13, color: "#94a3b8" }}>
//           {loading
//             ? "Loading..."
//             : `${doctors.length} doctor${doctors.length !== 1 ? "s" : ""} on team`}
//         </div>
//         <button
//           onClick={openAdd}
//           style={{
//             padding: "9px 22px",
//             borderRadius: 8,
//             border: "none",
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             cursor: "pointer",
//             fontSize: 13,
//             fontWeight: 700,
//             color: "#fff",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           + Add New Doctor
//         </button>
//       </div>

//       {loading ? (
//         <div
//           style={{
//             textAlign: "center",
//             padding: 40,
//             color: "#94a3b8",
//             fontSize: 14,
//           }}
//         >
//           Loading doctors...
//         </div>
//       ) : doctors.length === 0 ? (
//         <div
//           style={{
//             textAlign: "center",
//             padding: 48,
//             background: "#f8fafc",
//             borderRadius: 14,
//             color: "#94a3b8",
//             fontSize: 14,
//             border: "1px dashed #e2e8f0",
//           }}
//         >
//           No doctors added yet.
//           <br />
//           <button
//             onClick={openAdd}
//             style={{
//               marginTop: 12,
//               padding: "8px 20px",
//               borderRadius: 8,
//               border: "1px solid #0d7377",
//               background: "rgba(13,115,119,0.07)",
//               color: "#0d7377",
//               fontWeight: 700,
//               fontSize: 13,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Your First Doctor
//           </button>
//         </div>
//       ) : (
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
//             gap: 16,
//           }}
//         >
//           {doctors.map((doc) => (
//             <AdminCard
//               key={doc._id}
//               doc={doc}
//               onEdit={openEdit}
//               onDelete={handleDelete}
//               onToggle={handleToggle}
//             />
//           ))}
//         </div>
//       )}

//       {/* Info tip */}
//       <div
//         style={{
//           marginTop: 28,
//           background: "rgba(13,115,119,0.06)",
//           border: "1px solid rgba(13,115,119,0.2)",
//           borderRadius: 12,
//           padding: "14px 18px",
//         }}
//       >
//         <div
//           style={{
//             fontSize: 12,
//             fontWeight: 700,
//             color: "#0d7377",
//             marginBottom: 6,
//           }}
//         >
//           ℹ️ How this works
//         </div>
//         <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.75 }}>
//           • Doctors added here appear automatically on the public website's{" "}
//           <strong>Our Doctors</strong> section.
//           <br />
//           • Upload a real photo — it fits perfectly in the circular frame on the
//           card.
//           <br />
//           • Toggle availability to show a green/red dot on the website next to
//           the doctor's name.
//           <br />• Card colour, badge label, and all details update live the
//           moment you save.
//         </div>
//       </div>
//     </div>
//   );
// }

///////////////////////////// final test 2////////////////
// ============================================================
// src/components/admin/DoctorManageTab.js
// Complete Add Doctor tab — full CRUD, image upload, live preview
// Doctors added here appear live on the public Doctors section
// ============================================================
import React, { useState, useEffect, useCallback, useRef } from "react";
import api from "../../utils/api";

const CARD_COLORS = [
  {
    id: "teal",
    label: "Teal",
    bg: "linear-gradient(160deg,#0d7377 0%,#14a0a5 60%,#0a8f94 100%)",
  },
  {
    id: "navy",
    label: "Navy",
    bg: "linear-gradient(160deg,#0a1628 0%,#1a3a6b 100%)",
  },
  {
    id: "gold",
    label: "Gold",
    bg: "linear-gradient(160deg,#7c5a0a 0%,#b8860b 60%,#c9a845 100%)",
  },
  {
    id: "plum",
    label: "Plum",
    bg: "linear-gradient(160deg,#3b0764 0%,#6b21a8 100%)",
  },
  {
    id: "rose",
    label: "Rose",
    bg: "linear-gradient(160deg,#881337 0%,#be123c 100%)",
  },
  {
    id: "slate",
    label: "Slate",
    bg: "linear-gradient(160deg,#1e293b 0%,#475569 100%)",
  },
];

const getBg = (id) =>
  (CARD_COLORS.find((c) => c.id === id) || CARD_COLORS[0]).bg;

const SPECIALTIES = [
  "Chief Dental Surgeon",
  "Cosmetic & Aesthetic Dentist",
  "Orthodontics & Invisalign",
  "Root Canal Specialist",
  "Pediatric Dentist",
  "Oral & Maxillofacial Surgeon",
  "Periodontics Specialist",
  "Prosthodontics",
  "General Dentistry",
  "Dental Implant Specialist",
  "Teeth Whitening Specialist",
  "Smile Design Expert",
  "Other",
];

const ROLES = [
  "Chief Dental Surgeon",
  "Senior Dental Surgeon",
  "Junior Dental Surgeon",
  "Consultant Dentist",
  "Resident Dentist",
  "Specialist",
  "Head of Department",
  "Visiting Consultant",
  "Intern",
  "Other",
];

const BLANK = {
  name: "",
  specialty: "",
  role: "",
  qualification: "",
  experience: "",
  rating: "4.9",
  bio: "",
  badgeLabel: "",
  cardColor: "teal",
  image: "",
};

const INP = {
  width: "100%",
  padding: "9px 11px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  fontSize: 13,
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "'DM Sans',sans-serif",
  background: "#fff",
};
const LBL = {
  display: "block",
  fontSize: 11,
  fontWeight: 700,
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  marginBottom: 5,
};

// ── Live preview ──────────────────────────────────────────────────────
function PreviewCard({ f }) {
  const bg = getBg(f.cardColor);
  return (
    <div
      style={{
        borderRadius: 20,
        overflow: "hidden",
        width: "100%",
        maxWidth: 280,
        boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
        background: "#fff",
        fontFamily: "'DM Sans',sans-serif",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          background: bg,
          height: 200,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {f.badgeLabel && (
          <div
            style={{
              position: "absolute",
              top: 14,
              right: 14,
              background: "rgba(255,255,255,0.15)",
              backdropFilter: "blur(6px)",
              border: "1px solid rgba(255,255,255,0.3)",
              borderRadius: 20,
              fontSize: 11,
              fontWeight: 700,
              color: "#fff",
              padding: "4px 14px",
            }}
          >
            {f.badgeLabel}
          </div>
        )}
        {f.image ? (
          <img
            src={f.image}
            alt={f.name}
            style={{
              width: 130,
              height: 130,
              borderRadius: "50%",
              objectFit: "cover",
              objectPosition: "center top",
              border: "3px solid rgba(255,255,255,0.3)",
            }}
          />
        ) : (
          <div style={{ fontSize: 72, opacity: 0.7 }}>🧑‍⚕️</div>
        )}
      </div>
      <div style={{ padding: "22px 22px 20px" }}>
        <div
          style={{
            fontFamily: "Cormorant Garamond,serif",
            fontSize: 22,
            fontWeight: 700,
            color: "#0a1628",
            marginBottom: 3,
          }}
        >
          {f.name || "Doctor Name"}
        </div>
        <div
          style={{
            fontSize: 13,
            color: "#0d7377",
            fontWeight: 700,
            marginBottom: 10,
          }}
        >
          {f.specialty || "Specialty"}
        </div>
        <div
          style={{
            fontSize: 13,
            color: "#555",
            lineHeight: 1.6,
            marginBottom: 14,
            minHeight: 40,
          }}
        >
          {f.bio || "Doctor bio will appear here..."}
        </div>
        <div style={{ display: "flex", gap: 16, fontSize: 13, color: "#666" }}>
          {f.experience && <span>🎓 {f.experience} yrs exp.</span>}
          {f.rating && <span>⭐ {f.rating} ★</span>}
        </div>
      </div>
    </div>
  );
}

// ── Small admin list card — NO availability dot, NO toggle button ─────
function AdminCard({ doc, onEdit, onDelete }) {
  const bg = getBg(doc.cardColor);
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          background: bg,
          height: 80,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {doc.image ? (
          <img
            src={doc.image}
            alt={doc.name}
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              objectFit: "cover",
              objectPosition: "center top",
              border: "2px solid rgba(255,255,255,0.45)",
            }}
          />
        ) : (
          <div style={{ fontSize: 38, opacity: 0.75 }}>🧑‍⚕️</div>
        )}
      </div>
      <div style={{ padding: "12px 14px" }}>
        <div
          style={{
            fontWeight: 700,
            fontSize: 14,
            color: "#0a1628",
            marginBottom: 2,
          }}
        >
          {doc.name}
        </div>
        <div
          style={{
            fontSize: 11,
            color: "#0d7377",
            fontWeight: 600,
            marginBottom: 8,
          }}
        >
          {doc.specialty}
        </div>
        <div
          style={{
            display: "flex",
            gap: 10,
            fontSize: 11,
            color: "#888",
            marginBottom: 10,
          }}
        >
          {doc.experience && <span>🎓 {doc.experience} yrs</span>}
          {doc.rating && <span>⭐ {doc.rating}</span>}
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <button
            onClick={() => onEdit(doc)}
            style={{
              flex: 1,
              padding: "6px 0",
              borderRadius: 7,
              border: "1px solid #d1d5db",
              background: "#f8fafc",
              cursor: "pointer",
              fontSize: 11,
              fontWeight: 600,
              color: "#374151",
            }}
          >
            ✏️ Edit
          </button>
          <button
            onClick={() => onDelete(doc)}
            style={{
              padding: "6px 12px",
              borderRadius: 7,
              border: "1px solid #fca5a5",
              background: "#fef2f2",
              cursor: "pointer",
              fontSize: 11,
              fontWeight: 600,
              color: "#dc2626",
            }}
          >
            Del
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Main component ────────────────────────────────────────────────────
export default function DoctorManageTab({ showNotify }) {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("list");
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ ...BLANK });
  const [saving, setSaving] = useState(false);
  const [imgBusy, setImgBusy] = useState(false);
  const fileRef = useRef(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.get("/doctors/manage");
      setDoctors(Array.isArray(data) ? data : []);
    } catch (err) {
      showNotify("Error", err.message, true);
    }
    setLoading(false);
  }, [showNotify]);

  useEffect(() => {
    load();
  }, [load]);

  const sf = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const openAdd = () => {
    setEditing(null);
    setForm({ ...BLANK });
    setView("form");
  };

  const openEdit = (doc) => {
    setEditing(doc);
    setForm({
      name: doc.name || "",
      specialty: doc.specialty || "",
      role: doc.role || "",
      qualification: doc.qualification || "",
      experience: doc.experience || "",
      rating: doc.rating || "4.9",
      bio: doc.bio || "",
      badgeLabel: doc.badgeLabel || "",
      cardColor: doc.cardColor || "teal",
      image: doc.image || "",
    });
    setView("form");
  };

  const cancelForm = () => {
    setView("list");
    setEditing(null);
    setForm({ ...BLANK });
  };

  const handleImageFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 2.5 * 1024 * 1024) {
      showNotify("Image Too Large", "Please use an image under 2.5 MB.", true);
      return;
    }
    setImgBusy(true);
    const reader = new FileReader();
    reader.onload = (ev) => {
      sf("image", ev.target.result);
      setImgBusy(false);
    };
    reader.onerror = () => {
      showNotify("Error", "Could not read image.", true);
      setImgBusy(false);
    };
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      showNotify("Error", "Doctor name is required.", true);
      return;
    }
    if (!form.specialty.trim()) {
      showNotify("Error", "Specialty is required.", true);
      return;
    }
    setSaving(true);
    try {
      const payload = {
        name: form.name.trim(),
        specialty: form.specialty.trim(),
        role: form.role.trim(),
        qualification: form.qualification.trim(),
        experience: form.experience,
        rating: form.rating,
        bio: form.bio.trim(),
        badgeLabel: form.badgeLabel.trim(),
        cardColor: form.cardColor,
        image: form.image,
        isAvailable: true,
      };
      if (editing) {
        await api.put("/doctors/manage/" + editing._id, payload);
        showNotify(
          "Updated ✓",
          form.name + " profile updated. Live on website now.",
        );
      } else {
        await api.post("/doctors/manage", payload);
        showNotify(
          "Doctor Added ✓",
          form.name + " is now live on the website's Doctors section.",
        );
      }
      cancelForm();
      load();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
    setSaving(false);
  };

  const handleDelete = async (doc) => {
    if (
      !window.confirm(
        "Delete Dr. " +
          doc.name +
          " permanently? This will remove them from the website.",
      )
    )
      return;
    try {
      await api.delete("/doctors/manage/" + doc._id);
      showNotify("Deleted", doc.name + " removed.");
      load();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  // ════════════════ FORM VIEW ══════════════════════════════════════
  if (view === "form") {
    return (
      <div style={{ paddingBottom: 40 }}>
        <style>{`
          .dmt-form-grid { display: grid; grid-template-columns: 1fr 300px; gap: 20px; align-items: start; }
          .dmt-info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
          .dmt-card-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; align-items: start; }
          @media (max-width: 900px) { .dmt-form-grid { grid-template-columns: 1fr !important; } }
          @media (max-width: 600px) {
            .dmt-info-grid { grid-template-columns: 1fr !important; }
            .dmt-card-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>

        {/* Top bar */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 22,
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <div>
            <div className="admin-section-title" style={{ marginBottom: 2 }}>
              {editing ? "✏️ Edit Doctor" : "➕ Add New Doctor"}
            </div>
            <div style={{ fontSize: 12, color: "#94a3b8" }}>
              {editing
                ? "Changes go live on the website instantly."
                : "Doctor will appear live on the website's Doctors section."}
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={cancelForm}
              style={{
                padding: "9px 18px",
                borderRadius: 8,
                border: "1px solid #d1d5db",
                background: "#f8fafc",
                cursor: "pointer",
                fontSize: 13,
                fontWeight: 600,
                color: "#374151",
                fontFamily: "'DM Sans',sans-serif",
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              disabled={saving}
              style={{
                padding: "9px 22px",
                borderRadius: 8,
                border: "none",
                background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
                cursor: saving ? "default" : "pointer",
                fontSize: 13,
                fontWeight: 700,
                color: "#fff",
                opacity: saving ? 0.7 : 1,
                fontFamily: "'DM Sans',sans-serif",
              }}
            >
              {saving
                ? "Saving..."
                : editing
                  ? "💾 Update Doctor"
                  : "💾 Add Doctor"}
            </button>
          </div>
        </div>

        <div className="dmt-form-grid">
          {/* LEFT: form */}
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {/* Photo */}
            <div
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 14,
                padding: 18,
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 12,
                  color: "#1e40af",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  marginBottom: 14,
                }}
              >
                Doctor Photo
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 16,
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: 90,
                    height: 90,
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "2px solid #e5e7eb",
                    background: "#f8fafc",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {form.image ? (
                    <img
                      src={form.image}
                      alt="preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center top",
                      }}
                    />
                  ) : (
                    <span style={{ fontSize: 42 }}>🧑‍⚕️</span>
                  )}
                </div>
                <div style={{ flex: 1, minWidth: 180 }}>
                  <input
                    ref={fileRef}
                    type="file"
                    accept="image/jpeg,image/png,image/webp"
                    onChange={handleImageFile}
                    style={{ display: "none" }}
                  />
                  <button
                    onClick={() => fileRef.current && fileRef.current.click()}
                    disabled={imgBusy}
                    style={{
                      padding: "8px 18px",
                      borderRadius: 8,
                      border: "1px solid #0d7377",
                      background: "rgba(13,115,119,0.06)",
                      color: "#0d7377",
                      fontWeight: 700,
                      fontSize: 12,
                      cursor: imgBusy ? "default" : "pointer",
                      fontFamily: "'DM Sans',sans-serif",
                      marginBottom: 8,
                      display: "block",
                    }}
                  >
                    {imgBusy ? "Loading..." : "📸 Upload Photo"}
                  </button>
                  <div
                    style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}
                  >
                    JPEG / PNG / WebP · Max 2.5MB
                  </div>
                  <label style={LBL}>Or paste image URL</label>
                  <input
                    type="url"
                    value={
                      form.image && form.image.startsWith("data:")
                        ? ""
                        : form.image
                    }
                    onChange={(e) => sf("image", e.target.value)}
                    placeholder="https://example.com/photo.jpg"
                    style={INP}
                  />
                  {form.image && (
                    <button
                      onClick={() => sf("image", "")}
                      style={{
                        marginTop: 5,
                        background: "none",
                        border: "none",
                        color: "#ef4444",
                        fontSize: 11,
                        cursor: "pointer",
                        padding: 0,
                        fontFamily: "'DM Sans',sans-serif",
                      }}
                    >
                      ✕ Remove photo
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Basic info */}
            <div
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 14,
                padding: 18,
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 12,
                  color: "#1e40af",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  marginBottom: 14,
                }}
              >
                Basic Information
              </div>
              <div className="dmt-info-grid">
                <div>
                  <label style={LBL}>Full Name *</label>
                  <input
                    value={form.name}
                    onChange={(e) => sf("name", e.target.value)}
                    placeholder="Dr. Arjun Sharma"
                    style={INP}
                  />
                </div>
                <div>
                  <label style={LBL}>Specialty *</label>
                  <select
                    value={form.specialty}
                    onChange={(e) => sf("specialty", e.target.value)}
                    style={INP}
                  >
                    <option value="">— Select Specialty —</option>
                    {SPECIALTIES.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={LBL}>Role / Title</label>
                  <select
                    value={form.role}
                    onChange={(e) => sf("role", e.target.value)}
                    style={INP}
                  >
                    <option value="">— Select Role —</option>
                    {ROLES.map((r) => (
                      <option key={r} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={LBL}>Qualification</label>
                  <input
                    value={form.qualification}
                    onChange={(e) => sf("qualification", e.target.value)}
                    placeholder="BDS, MDS (Oral Surgery)"
                    style={INP}
                  />
                </div>
                <div>
                  <label style={LBL}>Years Experience</label>
                  <input
                    type="number"
                    min="0"
                    max="60"
                    value={form.experience}
                    onChange={(e) => sf("experience", e.target.value)}
                    placeholder="18"
                    style={INP}
                  />
                </div>
                <div>
                  <label style={LBL}>Rating (1–5)</label>
                  <input
                    type="number"
                    min="1"
                    max="5"
                    step="0.1"
                    value={form.rating}
                    onChange={(e) => sf("rating", e.target.value)}
                    placeholder="4.9"
                    style={INP}
                  />
                </div>
              </div>
              <div style={{ marginTop: 12 }}>
                <label style={LBL}>Bio / Description</label>
                <textarea
                  rows={3}
                  value={form.bio}
                  onChange={(e) => sf("bio", e.target.value)}
                  placeholder="BDS, MDS (Orthodontics). Certified Invisalign provider..."
                  style={{ ...INP, resize: "vertical", lineHeight: 1.55 }}
                />
              </div>
            </div>

            {/* Card appearance */}
            <div
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 14,
                padding: 18,
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 12,
                  color: "#1e40af",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  marginBottom: 14,
                }}
              >
                Card Appearance
              </div>
              <div className="dmt-card-grid">
                <div>
                  <label style={LBL}>Card Colour</label>
                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      flexWrap: "wrap",
                      marginTop: 4,
                    }}
                  >
                    {CARD_COLORS.map((c) => (
                      <button
                        key={c.id}
                        title={c.label}
                        onClick={() => sf("cardColor", c.id)}
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: "50%",
                          background: c.bg,
                          border:
                            form.cardColor === c.id
                              ? "3px solid #0a1628"
                              : "2px solid rgba(0,0,0,0.12)",
                          cursor: "pointer",
                          outline: "none",
                          boxShadow:
                            form.cardColor === c.id
                              ? "0 0 0 2px #fff inset"
                              : "none",
                          transition: "transform 0.15s",
                        }}
                      />
                    ))}
                  </div>
                </div>
                <div>
                  <label style={LBL}>Badge Label (top-right)</label>
                  <input
                    value={form.badgeLabel}
                    onChange={(e) => sf("badgeLabel", e.target.value)}
                    placeholder="e.g. Chief Surgeon"
                    style={INP}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT: preview */}
          <div>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#94a3b8",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginBottom: 12,
                textAlign: "center",
              }}
            >
              Live Preview
            </div>
            <PreviewCard f={form} />
            <div
              style={{
                marginTop: 10,
                fontSize: 11,
                color: "#94a3b8",
                textAlign: "center",
                lineHeight: 1.5,
              }}
            >
              This is exactly how the card
              <br />
              will appear on the website.
            </div>
          </div>
        </div>

        {/* Bottom save bar */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 24,
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={cancelForm}
            style={{
              padding: "10px 22px",
              borderRadius: 8,
              border: "1px solid #d1d5db",
              background: "#f8fafc",
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 600,
              color: "#374151",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            style={{
              padding: "10px 28px",
              borderRadius: 8,
              border: "none",
              background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
              cursor: saving ? "default" : "pointer",
              fontSize: 13,
              fontWeight: 700,
              color: "#fff",
              opacity: saving ? 0.7 : 1,
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            {saving
              ? "Saving..."
              : editing
                ? "💾 Update Doctor"
                : "💾 Add Doctor"}
          </button>
        </div>
      </div>
    );
  }

  // ════════════════ LIST VIEW ══════════════════════════════════════
  return (
    <div style={{ paddingBottom: 40 }}>
      <div className="admin-section-title">Manage Doctors</div>
      <div className="admin-section-desc" style={{ marginBottom: 18 }}>
        Add, edit or remove doctors. Changes appear{" "}
        <strong>live on the website instantly</strong> in the Doctors section.
        Upload real photos for best results.
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        <div style={{ fontSize: 13, color: "#94a3b8" }}>
          {loading
            ? "Loading..."
            : `${doctors.length} doctor${doctors.length !== 1 ? "s" : ""} on team`}
        </div>
        <button
          onClick={openAdd}
          style={{
            padding: "9px 22px",
            borderRadius: 8,
            border: "none",
            background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
            cursor: "pointer",
            fontSize: 13,
            fontWeight: 700,
            color: "#fff",
            fontFamily: "'DM Sans',sans-serif",
          }}
        >
          + Add New Doctor
        </button>
      </div>

      {loading ? (
        <div
          style={{
            textAlign: "center",
            padding: 40,
            color: "#94a3b8",
            fontSize: 14,
          }}
        >
          Loading doctors...
        </div>
      ) : doctors.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: 48,
            background: "#f8fafc",
            borderRadius: 14,
            color: "#94a3b8",
            fontSize: 14,
            border: "1px dashed #e2e8f0",
          }}
        >
          No doctors added yet.
          <br />
          <button
            onClick={openAdd}
            style={{
              marginTop: 12,
              padding: "8px 20px",
              borderRadius: 8,
              border: "1px solid #0d7377",
              background: "rgba(13,115,119,0.07)",
              color: "#0d7377",
              fontWeight: 700,
              fontSize: 13,
              cursor: "pointer",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            + Add Your First Doctor
          </button>
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
            gap: 16,
          }}
        >
          {doctors.map((doc) => (
            <AdminCard
              key={doc._id}
              doc={doc}
              onEdit={openEdit}
              onDelete={handleDelete}
            />
          ))}
        </div>
      )}

      <div
        style={{
          marginTop: 28,
          background: "rgba(13,115,119,0.06)",
          border: "1px solid rgba(13,115,119,0.2)",
          borderRadius: 12,
          padding: "14px 18px",
        }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: "#0d7377",
            marginBottom: 6,
          }}
        >
          ℹ️ How this works
        </div>
        <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.75 }}>
          • Doctors added here appear automatically on the public website's{" "}
          <strong>Our Doctors</strong> section.
          <br />
          • Upload a real photo — it fits perfectly in the circular frame on the
          card.
          <br />• Use <strong>Doctor Available</strong> tab to manage who is
          available for appointments.
          <br />• Card colour, badge label, and all details update live the
          moment you save.
        </div>
      </div>
    </div>
  );
}
